module.exports = __webpack_public_path__ + "img/default.9e74d33f.svg";